import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { CoercableComponent } from "features/feature";
import { computeComponent } from "util/vue";
import { toRefs } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    display: null
  },
  setup(__props: any) {

const _props = __props as { display: CoercableComponent }


const { display } = toRefs(_props);
const component = computeComponent(display);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(component))))
}
}

})